import { ButtonBasic, TextareaDynamicPlaceholder } from '@lk-gtcom/ecomlab-components';
import './ModalAddMassLink.scss';
import { useState } from 'react';
import { ModalComponent } from '../../../components/Modal/ModalComponent/ModalComponent';

const ModalAddMassLink = ({
    fetchAddLinks,
    setIsModal,
    initialValue = []
}) => {

    const [listLink, setListLink] = useState(initialValue.join('\n') || '')

    return (
        <ModalComponent
            title='Импорт ссылок'
            onClose={(e) => setIsModal(false)}
            style={{
                height: 'auto',
                maxWidth: '800px'
            }}
            child={
                <div className='modal-mass-editing'>
                    <TextareaDynamicPlaceholder
                        width='100%'
                        changeValue={listLink}
                        returnArr
                        placeholder="Введите ссылки через красную строку"
                        onChange={setListLink}
                    />
                    <ButtonBasic
                        green
                        text='Сохранить'
                        onClick={e => fetchAddLinks(listLink)}
                        style={{
                            minHeight: '40px'
                        }}
                    />
                </div>
            }
        />
    );
};

export { ModalAddMassLink };
